type AttributeMapping = {
  source: 'values' | 'payload';
  key: string;
};

const ATTRIBUTE_MAPPINGS: Record<string, AttributeMapping> = {
  user_name: { source: 'payload', key: 'user_name' },
  user_lastname: { source: 'payload', key: 'user_Lastname' },
  user_email: { source: 'payload', key: 'user_email' },
  user_phone: { source: 'payload', key: 'user_phone' },
  user_agent: { source: 'payload', key: 'user_agent' },
  user_cookie_consent: { source: 'values', key: 'user_cookie_consent' },
  pr_spouse: { source: 'values', key: 'pr_spouse' },
  pr_children: { source: 'values', key: 'pr_children' },
  pr_partners: { source: 'values', key: 'pr_partners' },
  sf_lead_country: { source: 'payload', key: 'sf_lead_country' },
  sf_lead_f_status: { source: 'payload', key: 'sf_lead_f_status' },
  fr_form_type: { source: 'payload', key: 'sf_lead_f_type' },
  pr_fs_goal: { source: 'values', key: 'pr_fs_goal' },
  ipcity: { source: 'payload', key: 'ipcity' },
  ipcountry: { source: 'payload', key: 'ipcountry' },
  // Device data
  da_device_vendor: { source: 'payload', key: 'da_device_vendor' },
  da_device_model: { source: 'payload', key: 'da_device_model' },
  da_marketing_name: { source: 'payload', key: 'da_marketing_name' },
  da_year_released: { source: 'payload', key: 'da_year_released' },
  fr_device_type: { source: 'payload', key: 'device_type' },
  fr_platform: { source: 'payload', key: 'platform' },
  // Form data
  fr_program_name: { source: 'payload', key: 'fr_program_name' },
  fr_program_country: { source: 'payload', key: 'fr_program_country' },
  fr_form_title: { source: 'payload', key: 'fr_form_title' },
  fr_form_id: { source: 'payload', key: 'fr_form_id' },
  fr_date_created: { source: 'payload', key: 'fr_date_created' },
  fr_ip: { source: 'payload', key: 'fr_ip' },
  page_url: { source: 'payload', key: 'fr_source_url' },
  domain: { source: 'payload', key: 'domain' },
  // ZeroBounce data
  zb_account: { source: 'payload', key: 'zb_account' },
  zb_domain: { source: 'payload', key: 'zb_domain' },
  zb_free_email: { source: 'payload', key: 'zb_free_email' },
  zb_smtp_provider: { source: 'payload', key: 'zb_smtp_provider' },
  zb_status: { source: 'payload', key: 'zb_status' },
  zb_sub_status: { source: 'payload', key: 'zb_sub_status' },
  // Meeting data
  mtg_connection_type: { source: 'values', key: 'mtg_connection_type' },
  mtg_date_user: { source: 'values', key: 'mtg_date_user' },
  mtg_manager_name: { source: 'values', key: 'mtg_manager_name' },
  mtg_program: { source: 'values', key: 'mtg_program' },
  mtg_questions: { source: 'values', key: 'mtg_questions' },
  mtg_time_manager: { source: 'values', key: 'mtg_time_manager' },
  mtg_time_user: { source: 'values', key: 'mtg_time_user' },
  mtg_type: { source: 'values', key: 'mtg_type' },
  mtg_user_time_zone: { source: 'values', key: 'mtg_user_time_zone' },
  // KYC
  kyc_last_name_c: { source: 'values', key: 'kyc_last_name_c' },
  kyc_first_name_с: { source: 'values', key: 'kyc_first_name_с' },
  kyc_middle_name_c: { source: 'values', key: 'kyc_middle_name_c' },
  kyc_country__c: { source: 'values', key: 'kyc_country__c' },
  kyc_city__c: { source: 'values', key: 'kyc_city__c' },
  kyc_street__c: { source: 'values', key: 'kyc_street__c' },
  kyc_postalcode__c: { source: 'values', key: 'kyc_postalcode__c' },
  kyc_business_area_c: { source: 'values', key: 'kyc_business_area_c' },
  kyc_business_geography_c: {
    source: 'values',
    key: 'kyc_business_geography_c',
  },
  kyc_sources_of_wealth_c: { source: 'values', key: 'kyc_sources_of_wealth_c' },
  kyc_proof_of_income_with_tax_returns_c: {
    source: 'values',
    key: 'kyc_proof_of_income_with_tax_returns_c',
  },
  kyc_proof_of_income_comment_c: {
    source: 'values',
    key: 'kyc_proof_of_income_comment_c',
  },
  kyc_connections_with_sanctioned_countries_c: {
    source: 'values',
    key: 'kyc_connections_with_sanctioned_countries_c',
  },
  kyc_sanctioned_countries_comment_c: {
    source: 'values',
    key: 'kyc_sanctioned_countries_comment_c',
  },
  kyc_refusal_in_visa_residency_citizenship_c: {
    source: 'values',
    key: 'kyc_refusal_in_visa_residency_citizenship_c',
  },
  kyc_refusal_in_visa_comment_c: {
    source: 'values',
    key: 'kyc_refusal_in_visa_comment_c',
  },
  kyc_permit_permanent_res_citizenship_c: {
    source: 'values',
    key: 'kyc_permit_permanent_res_citizenship_c',
  },
  kyc_permit_permanent_res_citizenship_comment_c: {
    source: 'values',
    key: 'kyc_permit_permanent_res_citizenship_comment_c',
  },
  kyc_criminal_record_c: { source: 'values', key: 'kyc_criminal_record_c' },
  kyc_criminal_record_comment_c: {
    source: 'values',
    key: 'kyc_criminal_record_comment_c',
  },
  kyc_personal_bankruptcy_c: {
    source: 'values',
    key: 'kyc_personal_bankruptcy_c',
  },
  kyc_personal_bankruptcy_comment_c: {
    source: 'values',
    key: 'kyc_personal_bankruptcy_comment_c',
  },
  kyc_pep_c: { source: 'values', key: 'kyc_pep_c' },
  kyc_pep_comment_c: { source: 'values', key: 'kyc_pep_comment_c' },
  kyc_sanctions_c: { source: 'values', key: 'kyc_sanctions_c' },
  kyc_sanctions_comment_c: { source: 'values', key: 'kyc_sanctions_comment_c' },
  kyc_business_activities_of_dependents_c: {
    source: 'values',
    key: 'kyc_business_activities_of_dependents_c',
  },
  kyc_business_activities_comment_c: {
    source: 'values',
    key: 'kyc_business_activities_comment_c',
  },
  kyc_registered_marriage_with_spouse_c: {
    source: 'values',
    key: 'kyc_registered_marriage_with_spouse_c',
  },
  kyc_sponsor_c: { source: 'values', key: 'kyc_sponsor_c' },
  kyc_additional_comments_c: {
    source: 'values',
    key: 'kyc_additional_comments_c',
  },
  kyc_b2b_title__c: { source: 'values', key: 'kyc_b2b_title__c' },
  kyc_b2b_companyname__c: { source: 'values', key: 'kyc_b2b_companyname__c' },
  kyc_b2b_website__c: { source: 'values', key: 'kyc_b2b_website__c' },
  kyc_b2b_reg_number__c: { source: 'values', key: 'kyc_b2b_reg_number__c' },
  kyc_b2b_registrationdate__c: {
    source: 'values',
    key: 'kyc_b2b_registrationdate__c',
  },
  kyc_b2b_legaladdress__c: { source: 'values', key: 'kyc_b2b_legaladdress__c' },
  kyc_b2b_actualaddress__c: {
    source: 'values',
    key: 'kyc_b2b_actualaddress__c',
  },
  kyc_b2b_companyscope__c: { source: 'values', key: 'kyc_b2b_companyscope__c' },
  kyc_b2b_minimal_standard__c: {
    source: 'values',
    key: 'kyc_b2b_minimal_standard__c',
  },
  kyc_b2b_annual_financial_statements__c: {
    source: 'values',
    key: 'kyc_b2b_annual_financial_statements__c',
  },
  kyc_confirmation1: { source: 'values', key: 'kyc_confirmation1' },
  kyc_confirmation2: { source: 'values', key: 'kyc_confirmation2' },
  kyc_confirmation3: { source: 'values', key: 'kyc_confirmation3' },
  select_role_1: { source: 'values', key: 'select_role_1' },
  select_role_2: { source: 'values', key: 'select_role_2' },
  select_role_3: { source: 'values', key: 'select_role_3' },
  select_role_4: { source: 'values', key: 'select_role_4' },
  select_role_5: { source: 'values', key: 'select_role_5' },
  select_role_6: { source: 'values', key: 'select_role_6' },
  select_role_7: { source: 'values', key: 'select_role_7' },
  select_role_8: { source: 'values', key: 'select_role_8' },
  select_role_9: { source: 'values', key: 'select_role_9' },
  select_role_10: { source: 'values', key: 'select_role_10' },
  // survey
  answer_1_customer_survey: {
    source: 'values',
    key: 'answer_1_customer_survey',
  },
  answer_2_customer_survey: {
    source: 'values',
    key: 'answer_2_customer_survey',
  },
  answer_3_customer_survey: {
    source: 'values',
    key: 'answer_3_customer_survey',
  },
  answer_4_customer_survey: {
    source: 'values',
    key: 'answer_4_customer_survey',
  },
  answer_5_customer_survey: {
    source: 'values',
    key: 'answer_5_customer_survey',
  },
  answer_6_customer_survey: {
    source: 'values',
    key: 'answer_6_customer_survey',
  },
  comment_customer_survey: { source: 'values', key: 'comment_customer_survey' },
  language_url: { source: 'payload', key: 'language_form' },
  timezone: { source: 'payload', key: 'timezone' },
  sf_timezone: { source: 'payload', key: 'sf_timezone' },
};

export const mapAmplitudeAttributes = (
  values: Record<string, any>,
  collectionDataPayload: Record<string, any>
) => {
  return Object.entries(ATTRIBUTE_MAPPINGS).reduce((acc, [key, mapping]) => {
    // Не заполняем fr_program_name для mtg формы
    if (key === 'fr_program_name' && values['mtg_program']) {
      return acc;
    }

    const source = mapping.source === 'values' ? values : collectionDataPayload;
    let value =
      mapping.key === 'user_email_consent'
        ? values[mapping.key] === '1'
        : source[mapping.key];

    if (key === 'mtg_manager_name' && typeof value === 'string') {
      value = value
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});
};
